module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "server-list"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.servers')))]), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": _vm.servers,
      "columns": ['fqdn', 'description'],
      "operations": _vm.operations
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('title.activate-server')
    },
    model: {
      value: (_vm.showActivateDialog),
      callback: function($$v) {
        _vm.showActivateDialog = $$v
      },
      expression: "showActivateDialog"
    }
  }, [_c('data-form', {
    attrs: {
      "entity": _vm.serverToActivate,
      "fields": _vm.activateFields,
      "cancelAction": _vm.cancelActivation
    },
    on: {
      "submit": _vm.activateServer
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('title.inactivate-server')
    },
    model: {
      value: (_vm.showInactivateDialog),
      callback: function($$v) {
        _vm.showInactivateDialog = $$v
      },
      expression: "showInactivateDialog"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.incativate-server')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.inactivateServer
    }
  }, [_vm._v(_vm._s(_vm.$t('button.inactivate')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showInactivateDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a3ff3ba0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/server/ServerList.vue
// module id = 1027
// module chunks = 2